<template>
  <div>
    <v-tabs
      v-if="isRv3434"
      v-model="activeTab"
      class="call-log-tabs mb-2"
      grow
    >
      <v-tab>Журнал звонков</v-tab>
      <v-tab>Расширенный журнал</v-tab>
    </v-tabs>

    <v-row align="center" class="pa-4">
      <v-card-title>{{ pageTitle }}</v-card-title>
      <div class="ml-2">
        <BaseTextField
          v-model="filterCode"
          :is-button="false"
          icon="mdi-magnify"
          :label="filterLabel"
        />
      </div>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer mt-1 mb-2"
            v-bind="attrs"
            v-on="on"
            :loading="refreshing"
            @click="updateInfo"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить</span>
      </v-tooltip>
    </v-row>

    <v-data-table
      class="table"
      :headers="tableHeaders"
      :items="tableItems"
      :footer-props="{
        'items-per-page-options': [10, 30, 50],
        showFirstLastPage: true,
      }"
    >
      <template v-slot:item.apartment_number="{ item }">
        <span>{{ item.apartment_number }}</span>
      </template>
      <template v-slot:item.door="{ item }">
        <div>
          <span :style="{ color: item.door_opened ? 'green' : 'red' }">
            {{ item.door_opened ? 'Дверь открыта' : 'Дверь не была открыта' }}
          </span>
        </div>
        <span v-if="item.opened_by">
          {{ item.opened_by === 'handset'
            ? 'Открыта через координатную трубку в квартире'
            : 'Открыта через мобильное приложение' }}
        </span>
      </template>
      <template v-slot:item.call="{ item }">
        <div>
          <span :style="{ color: item.call_answered ? 'green' : 'red' }">
            {{ item.call_answered ? 'Звонок был отвечен' : 'Звонок не был отвечен' }}
          </span>
        </div>
        <span v-if="item.answered_by">
          {{ item.answered_by === 'handset'
            ? 'Ответили через координатную трубку в квартире'
            : 'Ответили через мобильное приложение' }}
        </span>
      </template>
      <template v-slot:item.start_time="{ item }">
        <span>{{ ruDateFormat(item.start_time, false, true) }}</span>
      </template>

      <template v-slot:item.date="{ item }">
        {{ metDateTime(item.date, item.time) }}
      </template>
      <template v-slot:item.type="{ item }">
        {{ getType(item.type) }}
        {{ getCellType(item.call_type) }}
      </template>
      <template v-slot:item.status="{ item }">
        {{ getStatus(item.call_status) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  headersJournalSip,
  headersSipRV3434,
  headersSipBeward,
  CALL_TYPES,
  CALL_STATUS,
  TYPE,
} from '../consts';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import BaseTextField from '../../../BaseTextField';

export default {
  name: 'CallLog',
  components: { BaseTextField },
  mixins: [ruDateFormatMixin],
  props: ['id'],
  data () {
    return {
      headersJournalSip,
      headersSipRV3434,
      headersSipBeward,
      filterCode: '',
      activeTab: 0,
      refreshing: false,
      extendedJournalLoaded: false,
    };
  },
  created () {
    this.getData();
  },
  watch: {
    '$route.params.id' () {
      this.extendedJournalLoaded = false;
      this.activeTab = 0;
    },
    activeTab (tab) {
      if (this.isRv3434 && tab === 1 && !this.extendedJournalLoaded) {
        this.loadExtendedJournalOnce();
      }
    },
  },
  computed: {
    ...mapGetters({
      journalsip: 'Doorphone/journalsip',
      journalSipAllBeward: 'Doorphone/journalSipAllBeward',
      journalSipAllExtended: 'Doorphone/journalSipAllExtended',
      doorphone: 'Doorphone/doorphone',
    }),
    isRv3434 () {
      const model = this.doorphone.device && this.doorphone.device.model;
      if (!model) return false;
      return model === 'RV-3434' || model.name === 'RV-3434';
    },
    isExtendedView () {
      return this.isRv3434 && this.activeTab === 1;
    },
    isBewardView () {
      const device = this.doorphone.device;
      if (!device) {
        return false;
      }
      return device.manufacturer === 'Beward' || device.model === 'Sokol-Plus';
    },
    pageTitle () {
      if (this.isExtendedView) {
        return 'Расширенный журнал';
      }
      return 'Журнал звонков';
    },
    filterLabel () {
      if (this.isExtendedView || this.isBewardView) {
        return 'Введите номер квартиры';
      }
      return 'Введите номер ячейки';
    },
    tableHeaders () {
      if (this.isExtendedView || this.isBewardView) {
        return this.headersSipBeward;
      }
      if (this.isRv3434) {
        return this.headersSipRV3434;
      }
      return this.headersJournalSip;
    },
    sourceItems () {
      if (this.isExtendedView) {
        return this.journalSipAllExtended;
      }
      if (this.isBewardView) {
        return this.journalSipAllBeward;
      }
      return this.journalsip;
    },
    tableItems () {
      const items = this.sourceItems.slice().reverse();
      if (!this.filterCode) {
        return items;
      }
      const query = this.filterCode.toLowerCase();
      return items.filter((item) => {
        if (this.isExtendedView || this.isBewardView) {
          return String(item.apartment_number || '').toLowerCase().includes(query);
        }
        if (this.isRv3434) {
          return String(item.apartment || '').toLowerCase().includes(query);
        }
        return String(item.name || '').toLowerCase().includes(query);
      });
    },
  },
  methods: {
    ...mapActions({
      getJournalsip: 'Doorphone/getJournalsip',
      getJournalSipAllBeward: 'Doorphone/getJournalSipAllBeward',
      getJournalSipAllExtended: 'Doorphone/getJournalSipAllExtended',
      syncJournalSipExtended: 'Doorphone/syncJournalSipExtended',
    }),
    async loadExtendedJournalOnce () {
      await this.runWithRefreshing(async () => {
        await this.refreshExtendedJournal();
        this.extendedJournalLoaded = true;
      }, 'Не удалось получить расширенный журнал звонков');
    },
    async updateInfo () {
      await this.runWithRefreshing(async () => {
        if (this.isExtendedView) {
          await this.refreshExtendedJournal({ showSuccess: true });
        } else {
          await this.getData();
          this.$flash_success('Таблица обновлена!');
        }
      }, 'Не удалось обновить журнал звонков');
    },
    async runWithRefreshing (callback, errorMessage) {
      this.refreshing = true;
      try {
        await callback();
      } catch (err) {
        console.error(err);
        this.$flash_warning(errorMessage);
      } finally {
        this.refreshing = false;
      }
    },
    async refreshExtendedJournal ({ showSuccess = false } = {}) {
      await this.syncJournalSipExtended(this.$route.params.id);
      await this.getJournalSipAllExtended(this.$route.params.id);
      if (showSuccess) {
        this.$flash_success('Таблица обновлена!');
      }
    },
    async getData () {
      await this.getJournalsip(this.$route.params.id)
        .then(async () => {
          if (this.isBewardView) {
            await this.getJournalSipAllBeward(this.$route.params.id);
          }
        })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Не удалось получить журнал звонков');
        });
    },
    metDateTime (date, time) {
      const dateTime = date + ' ' + time;
      return this.ruDateFormat(dateTime);
    },
    getStatus (key) {
      return CALL_STATUS[key];
    },
    getCellType (key) {
      return CALL_TYPES[key];
    },
    getType (key) {
      return TYPE[key];
    },
  },
};
</script>

<style scoped>
.call-log-tabs::v-deep .v-tabs-bar {
  border-bottom: 1px solid #e2e4e7;
}
</style>
